import React from "react";
import { Box, Divider, Grid, GridItem, useColorModeValue } from "@chakra-ui/react";
import RiskReviewFieldRenderer from "./RiskReviewFieldRenderer";
import { sortBySequence } from "../../utils/riskReviewFormUtils";

const isFinancialType = (field) =>
  ["CURRENCY", "PERCENTAGE", "NUMBER", "DECIMAL", "CALCULATED"].includes(field.inputType);

const RiskReviewFinancialSummary = ({ fields, control, rules, errors, editable }) => {
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.200");
  const metricBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const visibleFields = sortBySequence(fields).filter(
    (field) => rules.visibility[field.code] !== false,
  );
  const metricFields = visibleFields.filter(isFinancialType);
  const otherFields = visibleFields.filter((field) => !isFinancialType(field));

  return (
    <Box>
      {metricFields.length ? (
        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          {metricFields.map((field) => (
            <GridItem key={field.code} colSpan={{ base: 12, md: 4, xl: Math.min(field.uiConfig?.width || 3, 4) }}>
              <Box bg={metricBg} borderWidth="1px" borderColor={borderColor} borderRadius="md" p={3} minH="92px">
                <RiskReviewFieldRenderer
                  field={field}
                  control={control}
                  disabled={!editable || rules.disabled[field.code]}
                  error={errors[field.code]}
                  required={rules.required[field.code]}
                  compact
                />
              </Box>
            </GridItem>
          ))}
        </Grid>
      ) : null}
      {metricFields.length && otherFields.length ? <Divider my={5} /> : null}
      {otherFields.length ? (
        <Grid templateColumns="repeat(12, 1fr)" gap={4}>
          {otherFields.map((field) => (
            <GridItem key={field.code} colSpan={{ base: 12, md: Math.min(field.uiConfig?.width || 6, 12) }}>
              <RiskReviewFieldRenderer
                field={field}
                control={control}
                disabled={!editable || rules.disabled[field.code]}
                error={errors[field.code]}
                required={rules.required[field.code]}
              />
            </GridItem>
          ))}
        </Grid>
      ) : null}
    </Box>
  );
};

export default RiskReviewFinancialSummary;
